const ROOT_PATH = '/wp-json/gg-portal/';

export function apiGet(path, rootPath = ROOT_PATH) {
  return fetch(`${rootPath}${path}`, {
    credentials: 'same-origin',
  });
}

export function apiPost(path, data, rootPath = ROOT_PATH) {
  return fetch(`${rootPath}${path}`, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
}
